<script setup>
import CustomButton from '@/components/Button/Button.vue';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';

const {
  label,
  type,
  uploadFiles,
  uploadError,
  onUploadTrigger,
  onDrop,
  onFileChange,
  onRemove,
} = defineProps({
  label: String,
  type: {
    type: String,
    required: true
  },
  uploadFiles: {
    type: Array,
    required: true
  },
  uploadError: {
    type: String,
    required: false
  },
  onUploadTrigger: Function,
  onDrop: Function,
  onFileChange: Function,
  onRemove: Function,
});


const fileInputRef = ref(null);
const isDragging = ref(false);

function triggerFileInput() {
  console.log('Upload button clicked');
  if (fileInputRef.value) {
    console.log('Input ref is valid, triggering click');
    fileInputRef.value.click();
  } else {
    console.warn('fileInputRef is null');
  }
}

const { t } = useI18n();
</script>

<template>
  <input
    ref="fileInputRef"
    type="file"
    multiple
    accept=".jpg,.png,.pdf"
    class="hidden"
    @change="(e) => onFileChange(e, type)"
  />
  <div class="customBoxClass mt-2 mb-5">
    <div
        class="bg-background-light flex justify-between align-center py-3.5 px-5 rounded-8xl licensesClass"
        :class="{ 'drag-active': isDragging }"
        @dragenter.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @dragover.prevent
        @drop.prevent="(e) => { isDragging = false; onDrop(e, type) }"
    >
      <div class="responsive-body-small">
        <div>{{ t(label) }}</div>
        <span class="semiboldText responsive-body-xsmall">{{ t('profile.fileRequirements') }}</span>
      </div>
      
      <!-- Upload button -->
      <div
          @click="triggerFileInput"
          class="px-4 py-1 responsive-body-small font-semibold text-bw-black border-[1px] border-black rounded-full hover:bg-bw-black hover:text-bw-white duration-200 cursor-pointer w-fit"
      >
        {{ t('profile.uploadFiles') }}
      </div>
    </div>

    <div v-if="uploadFiles.length > 0">
      <div v-for="file in uploadFiles" :key="file.uuid"
           class="flex justify-between align-center py-3.5 px-5 customBorder"
      >
        <div class="flex gap-3">
          <span class="responsive-body-small">{{ file.fileName || file.name }}</span>
          <span class="responsive-body-xsmall semiboldText">{{ file.size }}</span>
        </div>
        <div class="flex gap-3">
          <img v-if="file.status === 'uploaded'" src="@/assets/icons/svg/Check cycle_16x16.svg" />
          <img v-else-if="file.status === 'failed'" src="@/assets/icons/svg/exclamation.svg" />
          <img src="@/assets/icons/svg/Close_16x16.svg" class="cursor-pointer"
               @click="onRemove(file.uuid, type)" />
        </div>
      </div>
    </div>

    <div v-if="uploadError" class="text-notifications-red responsive-body-xsmall py-3.5 px-5 ">
      {{ uploadError }}
    </div>
  </div>
</template>


<style scoped>

 .drag-active {
   border: 2px dashed #1B84FF;
   background-color: #f0f8ff;
 }

 :deep(.v-switch__track) {
   opacity: 1;
 }
.semiboldText {
  color: #8C8B94;
}



.customBoxClass {
  border: 1px solid #EEEEF0;
  border-radius: 10px;
}

.customBorder {
  border-bottom: 1px solid #EEEEF0;
}

.progress {
  border-bottom: 1px solid #9BE7BA;
}

.drag-active {
  border: 2px dashed #1B84FF;
  background-color: #f0f8ff;
}

.rowClass {
  margin-bottom: -5px;
}

@media (max-width:768px) {
  .mainContainer {
    width: 100%;
    padding: 37px 20px;
  }

  .rowClass {
    flex-direction: column;
    gap: 0px;
  }

  .rmMobile {
    display: none;
  }

  .photoPass {
    flex-direction: row-reverse;
  }

  .licensesClass {
    flex-direction: column;
    gap: 10px;
  }

  .licensesClass>div,
  .licensesClass>button {
    align-self: start;
  }
}
</style>
